export const LANDING_PAGE_TITLE = "User Access Management Dashboard";
export const LOGIN_MESSAGE = "Please log in to access this page.";
export const USER_ROLES = ["Fragrance Community", "Non Fragrance Internal"];
export const MODIFY_DETAILS_CONFIRMATION_MESSAGE =
  "Are you sure you want to modify user details?";
export const MODIFY_DETAILS_ERROR_MESSAGE =
  "Something went wrong. Please try again!";
export const DELETE_USER_DETAILS_CONFIRMATION_MESSAGE =
  "Are you sure you want to delete user details?";
export const USER_ACTIONS = {
  MODIFY: "modify",
  DELETE: "delete",
};
export const DELETE_USER_SUCCESS_MESSAGE = "User details deleted successfully!";
export const UPDATE_USER_SUCCESS_MESSAGE = "User details updated successfully!";
export const TAB_NAMES = {
  AUDIT_LOGS: "Audit Logs",
  USER_ACCESS_MANAGEMENT: "User Access Management",
};
export const UAM_USER_ADMIN_AD_GROUP_DEV = "Sec-Azo-Fragrance Bank UAM - Dev";
export const UAM_USER_ADMIN_AD_GROUP_QA = "Sec-Azo-Fragrance Bank UAM - QA";
export const UAM_USER_ADMIN_AD_GROUP_PROD = "Sec-Azo-Fragrance Bank UAM - Prod";
export const UAM_USER_DIGITAL_AD_GROUP_DEV = "Sec-Azo-FragranceBank-Digital-Dev";
export const UAM_USER_DIGITAL_AD_GROUP_QA = "Sec-Azo-FragranceBank-Digital-QA";
export const UAM_USER_DIGITAL_AD_GROUP_PROD = "Sec-Azo-FragranceBank-Digital-Prod";

export const USER_FRAGRANCE_BANK_AD_GROUP_DEV =
  "Sec-Azo-FragranceBank-Digital-Dev";
export const USER_FRAGRANCE_BANK_AD_GROUP_QA =
  "Sec-Azo-FragranceBank-Digital-QA";
export const USER_FRAGRANCE_BANK_AD_GROUP_PROD =
  "Sec-Azo-FragranceBank-Digital-Prod";
  
export const DEV_APP_URL = "https://digital-library-dev.unilever.com";
export const QA_APP_URL = "https://digital-library-qa.unilever.com";
export const PROD_APP_URL = "https://digital-library.unilever.com";

export const RGB = ["Red", "Green", "Blue"];

export const USER_ACCESS_MANAGEMENT_TABS = ['User Access Management', 'Bulk Edit Fragrances', 'Bulk Edit Associations', 'Rename Fragrance Fields'];
export const DIGITAL_ACCESS_MANAGEMENT_TABS = ['Bulk Edit Fragrances', 'Bulk Edit Associations', 'Rename Fragrance Fields'];
export const OLFACTIVES = [ "Primary Olfactive Descriptor", "Secondary Olfactive Descriptor", "Olfactive Identifier" ];
export const FRAGRANCE_FIELDS_VALIDATION_ERROR_MESSAGE = "One or more fragrances are missing required field : "
